import { render } from "./add-product.vue?vue&type=template&id=ecf0e014"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"

import "./add-product.vue?vue&type=style&index=0&id=ecf0e014&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__